'use client';

import {default as Image} from '@/components/global/images/resized-cdn-image';
import { useParams } from 'next/navigation';
import React from 'react';

import { doTranslation } from '@/app/i18n/client';
import creditCard from '@/public/assets/images/global/bus-station/credit-card.svg';
import styles from '@/components/bus-station/bus-station-payment-icon.module.scss';

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  paymentForms: any;
}

const BusStationPaymentIcon = (props: Props): React.JSX.Element => {
  const { lng }: any = useParams();
  const { t } = doTranslation(lng);

  return (
    <div className={styles.card}>
      <div className={styles.content}>
        <div className={styles.header}>
          <Image alt={t('Credit Card')} height="36" src={creditCard} width="36" />
          <h2 className={styles.title}>{t('Ticket Counter Payment Methods Accepted')}</h2>
        </div>
        <div className={styles.body}>
          <div className={styles.row}>
            {props.paymentForms.map((paymentForm: any, index: number) => {
              return (
                <Image
                  alt={t(paymentForm.attributes.payment_form)}
                  height="35"
                  key={index}
                  src={`/assets/images/global/bus-station/${paymentForm.attributes.payment_form
                    .replace(/[^a-zA-Z0-9]+/g, '-')
                    .toLowerCase()}.svg`}
                  width="34"
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusStationPaymentIcon;
